import { Suspense } from 'react';
import { Reward } from '../features';

const RewardScreen = () => {
    return (
        <Suspense fallback={null}>
            <Reward />
        </Suspense>
    );
};
export default RewardScreen;
